//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Modal from '@nextcloud/vue/dist/Components/Modal';
export default {
  name: 'PublicFilesEditor',
  components: {
    Modal: Modal,
    EditorWrapper: function EditorWrapper() {
      return import(
      /* webpackChunkName: "editor" */
      './EditorWrapper');
    }
  },
  props: {
    fileId: {
      type: Number,
      default: null
    },
    relativePath: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    shareToken: {
      type: String,
      default: null
    },
    mimeType: {
      type: String,
      default: null
    }
  },
  computed: {
    fileName: function fileName() {
      return this.relativePath.substring(this.relativePath.lastIndexOf('/') + 1);
    }
  },
  methods: {
    close: function close() {
      this.active = false;
    }
  }
};